export default id => {
  const klaviyoData = document.querySelector(`.js-productKlaviyoData[data-product-id="${id}"]`);

  return {
    Name: klaviyoData.dataset.name,
    ProductID: parseInt(klaviyoData.dataset.productId),
    Categories: klaviyoData.dataset.categories.split(','),
    ImageURL: klaviyoData.dataset.imageUrl,
    URL:  klaviyoData.dataset.url,
    Brand: klaviyoData.dataset.brand,
    Price: klaviyoData.dataset.price,
    CompareAtPrice: klaviyoData.dataset.compareAtPrice,
  }
}
